import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
import { PATH_MANAGEMENT } from '../../../../routes/paths';
import PermissionMenuItem from '../../../../components/permission/PermissionMenuItem';
import { PermissionPath } from 'src/components/permission/PermissionPath';

import { fDateTimeJalali } from 'src/utils/formatTime';
ClosureShopsRow.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelectRow: PropTypes.func,
  onViewRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onShowNumbers: PropTypes.func,
  onShowOwners: PropTypes.func,
};

export default function ClosureShopsRow({ row }) {
  const { name, holidays_info } = row;

  return (
    <TableRow
      hover
      sx={{
        '&:nth-of-type(odd)': {
          bgcolor: 'background.neutral',
        },
        '&:nth-of-type(even)': {
          bgcolor: 'background',
        },
      }}
    >
      <TableCell align="left">{fDateTimeJalali(holidays_info?.created_at)}</TableCell>
      <TableCell align="left">{holidays_info?.descriptions}</TableCell>
      <TableCell align="left">{fDateTimeJalali(holidays_info?.start)}</TableCell>
      <TableCell align="left"> {fDateTimeJalali(holidays_info?.end)}</TableCell>
      <TableCell align="left">
        <PermissionMenuItem
          title={name}
          permission={PermissionPath.shop.update}
          shopId={row.id}
          onPress={() => {
            window.open(PATH_MANAGEMENT.management.editShop.shopInvioce(row.id), '_blank');
          }}
          visible={true}
        />
      </TableCell>
      <TableCell align="left"> {holidays_info?.added_by?.name}</TableCell>
      <TableCell align="left"> {holidays_info?.added_by?.username}</TableCell>
    </TableRow>
  );
}
